import { motion } from "motion/react"
import Enconstruccion from "./Enconstruccion"

const Presentacion = () => {
  return (
    <Enconstruccion/>
  )
}

export default Presentacion
